// extracted by mini-css-extract-plugin
module.exports = {"form":"InvitePosUsers_form__FGCDd","header":"InvitePosUsers_header__35bRC","subHeader":"InvitePosUsers_subHeader__3SALA"};